import { trapFocus, removeTrapFocus } from '../common'

class CartNotification extends HTMLElement {
  constructor () {
    super()

    this.notificationWrapper = document.querySelector('.cart-notification-wrapper')
    this.notification = document.getElementById('cart-notification')
    this.header = document.querySelector('sticky-header')
    this.onBodyClick = this.handleBodyClick.bind(this)

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close())
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    )
  }

  open () {
    this.notificationWrapper.classList.add('animate', 'active')

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus()
      trapFocus(this.notification)
    }, { once: true })

    document.body.addEventListener('click', this.onBodyClick)
  }

  close () {
    this.notificationWrapper.classList.remove('active')

    document.body.removeEventListener('click', this.onBodyClick)

    removeTrapFocus(this.activeElement)
  }

  renderContents (parsedState) {
    this.cartItemKey = parsedState.key
    this.getSectionsToRender().forEach(section => {
      const sectionElement = document.getElementById(section.id)
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
      if (document.getElementById(`${section.id}_md`)) {
        document.getElementById(`${section.id}_md`).innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector)
      }
    })

    if (this.header) {
      this.header.reveal()
    }
    this.open()
  }

  getSectionsToRender () {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'header-cart-count'
      }
    ]
  }

  getSectionInnerHTML (html, selector = '.shopify-section') {
    if (html !== null && selector !== null) {
      const parsedDOM = new DOMParser().parseFromString(html, 'text/html')
      const innerHTML = parsedDOM.querySelector(selector).innerHTML
      return innerHTML
    } else {
      // TODO:
      console.error('HTML or selector are null', html, selector)
    }
  }

  handleBodyClick (evt) {
    const target = evt.target
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu')
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null
      this.close()
    }
  }

  setActiveElement (element) {
    this.activeElement = element
  }
}

customElements.define('cart-notification', CartNotification)
